<template>
  <router-view />
  <BaseToast />
</template>

<script setup lang="ts">
  import BaseToast from './components/BaseToast.vue'
</script>
